import { EpimsBaseEntityDto } from './epim-base.dto';
export class AccessRightDto extends EpimsBaseEntityDto {
  name: string;
  value: string;
  ModuleActivity_ActivityId: string;
  SubscriptionUserId: string;
  Version: number;
}
